import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkUpdateMaterialResponse = ClientInferResponseBody<
  typeof contract.quoteRequestLines.bulkUpdateMaterial,
  200
>;

export type BulkUpdateMaterialPayload = ClientInferRequest<
  typeof contract.quoteRequestLines.bulkUpdateMaterial
>["body"];

export const bulkUpdateMaterial = async (
  payload: BulkUpdateMaterialPayload,
): Promise<BulkUpdateMaterialResponse> => {
  const response = await api.quoteRequestLines.bulkUpdateMaterial.mutation({
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError(
    "Une erreur est survenue lors de la mise à jour de la matière",
    response.status,
    response.body,
  );
};
